class ImageSlider {
  constructor(root) {
    this.root = root;
    this.track = root.querySelector('.image-slider__track');
    this.slides = Array.from(root.querySelectorAll('.image-slider__slide'));
    this.controls = Array.from(root.querySelectorAll('[data-slide-to]'));
    this.prevButton = root.querySelector('[data-action="prev"]');
    this.nextButton = root.querySelector('[data-action="next"]');
    this.counterCurrent = root.querySelector('.image-slider__current');
    this.counterTotal = root.querySelector('.image-slider__total');
    this.currentIndex = 0;
    this.timer = null;
    this._touchStartX = 0;
    this._touchStartY = 0;

    if (!this.track || this.slides.length === 0) return;

    this.autoplay = this.track.dataset.autoplay === 'true';
    this.interval = Math.max(2, parseInt(this.track.dataset.interval || '5', 10));
    this.loop = this.track.dataset.loop === 'true';

    this.bindEvents();
    this.updateUI(0);

    if (this.slides.length > 1) {
      this.startAutoplay();
    }
  }

  bindEvents() {
    // Pagination dots / numbers
    this.controls.forEach((control) => {
      control.addEventListener('click', () => {
        const index = parseInt(control.dataset.slideTo, 10);
        if (!Number.isNaN(index)) this.goTo(index);
      });
    });

    // Arrow navigation
    if (this.prevButton) {
      this.prevButton.addEventListener('click', () => this.goTo(this.currentIndex - 1));
    }
    if (this.nextButton) {
      this.nextButton.addEventListener('click', () => this.goTo(this.currentIndex + 1));
    }

    // Pause on hover
    this.root.addEventListener('mouseenter', () => this.stopAutoplay());
    this.root.addEventListener('mouseleave', () => this.startAutoplay());

    // Touch / swipe
    this.root.addEventListener('touchstart', (e) => {
      this._touchStartX = e.changedTouches[0].clientX;
      this._touchStartY = e.changedTouches[0].clientY;
    }, { passive: true });

    this.root.addEventListener('touchend', (e) => {
      const dx = e.changedTouches[0].clientX - this._touchStartX;
      const dy = e.changedTouches[0].clientY - this._touchStartY;
      if (Math.abs(dx) > Math.abs(dy) && Math.abs(dx) > 40) {
        this.goTo(dx < 0 ? this.currentIndex + 1 : this.currentIndex - 1);
      }
    }, { passive: true });

    // Keyboard
    this.root.addEventListener('keydown', (e) => {
      if (e.key === 'ArrowLeft') this.goTo(this.currentIndex - 1);
      if (e.key === 'ArrowRight') this.goTo(this.currentIndex + 1);
    });
  }

  goTo(index) {
    if (this.slides.length === 0) return;
    
    let normalized = index;
    if (this.loop) {
      normalized = ((index % this.slides.length) + this.slides.length) % this.slides.length;
    } else {
      normalized = Math.max(0, Math.min(index, this.slides.length - 1));
      // If we reached the end during autoplay and loop is off, stop autoplay
      if (index >= this.slides.length && this.timer) {
        this.stopAutoplay();
        return;
      }
    }

    this.updateUI(normalized);
    if (this.slides.length > 1) this.restartAutoplay();
  }

  updateUI(index) {
    this.currentIndex = index;

    this.slides.forEach((slide, i) => {
      slide.classList.toggle('is-active', i === index);
    });

    this.controls.forEach((control) => {
      const ci = parseInt(control.dataset.slideTo, 10);
      const active = ci === index;
      control.classList.toggle('is-active', active);
      if (active) {
        control.setAttribute('aria-current', 'true');
      } else {
        control.removeAttribute('aria-current');
      }
    });

    if (this.counterCurrent) this.counterCurrent.textContent = String(index + 1);
    if (this.counterTotal) this.counterTotal.textContent = String(this.slides.length);
  }

  startAutoplay() {
    if (!this.autoplay || this.slides.length < 2) return;
    this.stopAutoplay();
    this.timer = setInterval(() => this.goTo(this.currentIndex + 1), this.interval * 1000);
  }

  stopAutoplay() {
    if (this.timer) {
      clearInterval(this.timer);
      this.timer = null;
    }
  }

  restartAutoplay() {
    this.stopAutoplay();
    this.startAutoplay();
  }

  destroy() {
    this.stopAutoplay();
  }
}

function initImageSlider(sectionId) {
  const root = document.getElementById('ImageSlider-' + sectionId);
  if (!root) return;

  const key = 'imageSliderInstance_' + sectionId;
  if (window[key] && typeof window[key].destroy === 'function') {
    window[key].destroy();
  }

  window[key] = new ImageSlider(root);
}

// Initialize all sliders on the page on load
function initAllImageSliders() {
  document.querySelectorAll('.image-slider[id^="ImageSlider-"]').forEach(function (root) {
    var sectionId = root.id.replace('ImageSlider-', '');
    initImageSlider(sectionId);
  });
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initAllImageSliders);
} else {
  initAllImageSliders();
}

// Theme editor events
document.addEventListener('shopify:section:load', function (event) {
  if (event.detail && event.detail.sectionId) {
    initImageSlider(event.detail.sectionId);
  }
});

document.addEventListener('shopify:section:reorder', function (event) {
  if (event.detail && event.detail.sectionId) {
    initImageSlider(event.detail.sectionId);
  }
});

document.addEventListener('shopify:block:select', function (event) {
  if (!event.detail) return;
  var sectionId = event.detail.sectionId;
  var key = 'imageSliderInstance_' + sectionId;
  var slider = window[key];
  if (!slider) return;

  var root = document.getElementById('ImageSlider-' + sectionId);
  if (!root) return;
  // Find slide matching this block via shopify_attributes
  var slides = Array.from(root.querySelectorAll('.image-slider__slide'));
  var idx = slides.findIndex(function (s) {
    return s.getAttribute('data-shopify-editor-block') === event.detail.blockId;
  });
  if (idx === -1) {
    // Fallback: find by data-slide-index matching block order
    var blockEl = root.querySelector('[id="' + event.detail.blockId + '"]');
    if (blockEl) idx = parseInt(blockEl.dataset.slideIndex, 10);
  }
  if (!Number.isNaN(idx) && idx !== -1) {
    slider.stopAutoplay();
    slider.updateUI(idx);
  }
});

document.addEventListener('shopify:block:deselect', function (event) {
  if (!event.detail) return;
  var key = 'imageSliderInstance_' + event.detail.sectionId;
  if (window[key]) window[key].startAutoplay();
});
